module.exports = __webpack_public_path__ + "assets/img/help_image04-3.0b35ecfb.png";